import { Config } from "../Config";
import { FaceTecSDK } from "../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { LivenessCheckProcessor } from "./processors/LivenessCheckProcessor";
import { FaceTecSDKProcessor } from "./processors/FaceTecSDKProcessor";
import { SampleAppUtilities } from "./utilities/SampleAppUtilities";
import { FaceTecStringsES, FaceTecStringsEN } from "./language/FaceTecStrings";
import { i18nInstance } from "../i18n";
import { sendLivenessMessage } from "../helpers/postMessageHelper";
import constants, { KEY_LOCAL_STORAGE, KEY_LOCAL_STORAGE_GEO, } from "../constants";
import { NetworkingRequest } from "./utilities/NetworkingRequest";
export var SampleApp = (function () {
    var latestProcessor;
    var apiKey = "";
    var functionTrack = null;
    var onLivenessSessionEnd = null;
    var faceTecSDKInstance = null;
    var onFaceTecReadyCallback = null;
    var isFaceTecReady = false;
    var hasInitialized = false;
    function onFaceTecReady(cb) {
        onFaceTecReadyCallback = cb;
        if (isFaceTecReady)
            cb();
    }
    function setExternalConfig(api, track) {
        apiKey = api;
        functionTrack = track;
        NetworkingRequest.setClientApiKey(api);
    }
    function setOnLivenessSessionEnd(cb) {
        onLivenessSessionEnd = cb;
    }
    function getOptionalHeader() {
        try {
            if (typeof FaceTecSDK.getTestingAPIHeader === "function") {
                return FaceTecSDK.getTestingAPIHeader() || "";
            }
        }
        catch (_a) {
            // ignore
        }
        return "";
    }
    function safeDisplayStatus(message) {
        if (typeof document === "undefined")
            return;
        if (!document.getElementById("status"))
            return;
        SampleAppUtilities.displayStatus(message);
    }
    function initialize() {
        if (hasInitialized) {
            return;
        }
        hasInitialized = true;
        SampleAppUtilities.disableAllButtons();
        FaceTecSDK.setResourceDirectory("./core-sdk/FaceTecSDK.js/resources");
        FaceTecSDK.setImagesDirectory("./core-sdk/FaceTec_images");
        SampleAppUtilities.formatUIForDevice();
        new FaceTecSDKProcessor({
            onSuccess: handleInitializeSuccess,
            onError: handleInitializeError,
        }).initialize();
    }
    function handleInitializeSuccess(newFaceTecSdkInstance) {
        faceTecSDKInstance = newFaceTecSdkInstance;
        isFaceTecReady = true;
        if (i18nInstance.language == "es") {
            FaceTecSDK.configureLocalization(FaceTecStringsES);
        }
        else {
            FaceTecSDK.configureLocalization(FaceTecStringsEN);
        }
        SampleAppUtilities.themeCustomatizationMaat();
        if (onFaceTecReadyCallback)
            onFaceTecReadyCallback();
        var message = i18nInstance.t("faceTec-initMessage");
        SampleAppUtilities.displayStatus(message);
    }
    function handleInitializeError(initializationError) {
        var message = i18nInstance.t("faceTec-initMessage");
        safeDisplayStatus(message);
        setTimeout(function () {
            var canPostMessage = Config.InIframe || Config.messageParent || Boolean(window.opener);
            if (canPostMessage) {
                sendLivenessMessage({
                    cmd: "recognition-response",
                    resultAction: "ConnectionError",
                    code: "".concat(initializationError),
                });
            }
        }, 1000);
    }
    function onLivenessCheckPressed() {
        if (!faceTecSDKInstance) {
            SampleAppUtilities.handleErrorGettingServerSessionToken();
            if (onLivenessSessionEnd)
                onLivenessSessionEnd();
            return;
        }
        SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        latestProcessor = new LivenessCheckProcessor(faceTecSDKInstance, SampleApp);
    }
    function onComplete(event) {
        var _a;
        SampleAppUtilities.showMainUI();
        if (onLivenessSessionEnd)
            onLivenessSessionEnd();
        var header = getOptionalHeader();
        var image = (_a = event.auditTrail) !== null && _a !== void 0 ? _a : [];
        var successful = event.successful && event.livenessProven;
        if (!successful) {
            if (functionTrack)
                functionTrack(constants.UNSUCCESS, apiKey);
            setTimeout(function () {
                sendLivenessMessage({
                    cmd: "recognition-response",
                    resultAction: event.successful
                        ? constants.UNSUCCESS
                        : "ConnectionError",
                    header: header,
                    code: event.sessionStatus != null ? "".concat(event.sessionStatus) : "",
                    image: image,
                });
            }, 1000);
            return;
        }
        if (functionTrack)
            functionTrack(constants.SUCCESS, apiKey);
        setTimeout(function () {
            sendLivenessMessage({
                cmd: "recognition-response",
                resultAction: constants.SUCCESS,
                header: header,
                image: image,
                codeProcess: localStorage.getItem(KEY_LOCAL_STORAGE) || "",
            });
            localStorage.setItem(KEY_LOCAL_STORAGE_GEO, "");
        }, 1000);
        var message = i18nInstance.t("faceTec-success");
        SampleAppUtilities.displayStatus(message);
    }
    function setLogoId(id) {
        return "".concat(Config.baseDomain, "/api/files/serve?id=").concat(id);
    }
    return {
        initialize: initialize,
        setExternalConfig: setExternalConfig,
        setOnLivenessSessionEnd: setOnLivenessSessionEnd,
        onLivenessCheckPressed: onLivenessCheckPressed,
        onComplete: onComplete,
        setLogoId: setLogoId,
        onFaceTecReady: onFaceTecReady,
    };
})();
